import {InputController} from "./InputController";

declare const toastui: any;

/** Markdown Editor */
export class MarkdownEditorController extends InputController {

  private _value: string;
  private editor: any;

  public static $inject = ["$element", "$scope", "$attrs", "$timeout"];

  /**
   * Creates a new MarkdownEditorController
   * @ignore
   */
  constructor(private $element: JQLite, private $scope: angular.IScope, private $attrs: angular.IAttributes, private $timeout: angular.ITimeoutService) {
    super();
  }

  /** Init */
  public $onInit = () => {
    super.$onInit();
    this.editor = toastui.Editor.factory({
      el: this.$element[0].querySelector("#editor"),
      viewer: false,
      height: "500px",
      initialEditType: "wysiwyg",
      previewStyle: "vertical",
      hideModeSwitch: true,
    });
    this.editor.addHook("change", () =>  {
      this._value = this.editor.getMarkdown();
      this.value = this._value;
      this.onChange();
    });
    this.$scope.$watch(this.$attrs.ngModel, (newValue) => {
      this.changeValue(newValue as any);
    });
  };

  /** Value initialization */
  public onInitValue(){
    this.changeValue(this.value);
  }

  /** New value */
  public changeValue(newValue: string) {
    if (newValue == this._value) {
      return;
    }
    this._value = newValue;
    this.editor.setMarkdown(newValue);
    this.$timeout();
  }
}

